import join from 'url-join';

import { asyncAction, http } from '../util/';

const { VITE_API2_URL: api2Url } = import.meta.env;
const api2 = join(api2Url, 'v1');

export const getCurrentUser = asyncAction({
  baseName: 'GET_CURRENT_USER',
  action: action => () => dispatch => {
    dispatch(action.start());

    return http
      .get(join(api2, '/users/current'))
      .then(({ data: response }) => {
        const userData = {
          ...response,
          accountDepartments: response.accountDepartments.map(dept => ({
            ...dept,
            accountId: `${dept.accountId}`,
            departments: dept.departments.map(dept => `${dept}`)
          }))
        };

        return dispatch(action.success(userData));
      })
      .catch(error => dispatch(action.error(error)));
  }
});
